// extracted by mini-css-extract-plugin
export var pillWrapper = "_rb-0";
export var showOverflow = "_rb-1";